<template>
  <div class="wrapper">
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="visible" @close="close">
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        label-width="120px"
        :inline="false"
        size="normal"
        :disabled="formDisabled"
      >
        <el-form-item label="专员" prop="wlUserId">
          <el-select
            v-model="form.wlUserId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in wlUserOptions"
              :key="item.wlUserId"
              :label="item.name + ' - ' + item.phone"
              :value="item.wlUserId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指导员" prop="gssId">
          <el-select
            v-model="form.gssId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethodGss"
            :loading="loading"
          >
            <el-option
              v-for="item in GSSOptions"
              :key="item.id"
              :label="item.userName + ' - ' + item.phone"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="formDiv">
          <span>入职日期</span>
          <el-date-picker
            v-model="form.entryTime"
            type="datetime"
            placeholder="选择日期时间"
            default-time="00:00:00"
          ></el-date-picker>
        </div>
        <div class="formDiv">
          <span>离职日期</span>
          <el-date-picker
            v-model="form.leaveTime"
            type="datetime"
            placeholder="选择日期时间"
            default-time="19:00:00"
          ></el-date-picker>
        </div>
        <div class="formDiv">
          <span>报备日期</span>
          <el-date-picker
            v-model="form.happenTime"
            type="datetime"
            placeholder="选择日期时间"
            default-time="00:00:00"
          ></el-date-picker>
        </div>
        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择类型">
            <el-option
              v-for="item in typeCodeList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="照片" v-if="!formDisabled">
          <el-upload
            action
            ref="staffImgUpload"
            :file-list="fileList"
            :limit="3"
            :on-exceed="surpass"
            list-type="picture-card"
            :http-request="importFile"
            :on-remove="staffImgRemove"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePictureCardPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="照片" v-else>
          <el-image
            v-for="(item, index) in form.photo"
            :key="index"
            style="width: 100px; height: 100px; margin-right: 2px"
            :src="item"
            :preview-src-list="form.photo"
          >
            <div slot="error" class="image-slot">
              <i style="font-size: 110px" class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" v-if="!formDisabled">
        <el-button @click="visible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="handleOk" size="mini" :disabled="submitStaffBtnBool">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>

    <!-- 审批 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="examineShow"
      @close="examineClose"
    >
      <el-form
        :model="examineForm"
        ref="examineFormRules"
        :rules="examineFormRules"
        label-width="120px"
        :inline="false"
        size="normal"
        :disabled="examineApproveType"
      >
        <el-form-item label="扣除原因">
          <el-input :value="examineInfo.causeType" disabled></el-input>
        </el-form-item>
        <el-form-item label="报备日期">
          <el-input :value="examineInfo.happenTime" disabled></el-input>
        </el-form-item>
        <!-- <el-form-item label="时段">
          <el-input :value="examineInfo.duration" disabled></el-input>
        </el-form-item>-->
        <el-form-item label="开始时间">
          <el-input :value="examineInfo.startTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-input :value="examineInfo.endTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="三方检查社区">
          <el-input type="textarea" autosize :value="examineInfo.communityNames" disabled></el-input>
        </el-form-item>
        <el-form-item label="照片">
          <el-image
            v-for="(item, index) in examineInfo.photo"
            :key="index"
            style="width: 100px; height: 100px; margin-right: 2px"
            :src="item"
            :preview-src-list="examineInfo.photo"
          >
            <div slot="error" class="image-slot">
              <i style="font-size: 110px" class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </el-form-item>
        <el-form-item label="备注">
          <el-input :value="examineInfo.remark" disabled></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <div v-if="examineInfo.status !== 2 && examineInfo.status !== 3">
          <el-form-item label="审批" prop="status">
            <el-radio-group v-model="examineForm.status">
              <el-radio label="2">通过</el-radio>
              <el-radio label="3">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审批意见">
            <el-input type="textarea" v-model="examineForm.auditRemark"></el-input>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="审批" prop="status">
            <el-radio-group :value="examineInfo.status + ''">
              <el-radio label="2">通过</el-radio>
              <el-radio label="3">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审批意见">
            <el-input type="textarea" :value="examineInfo.auditRemark"></el-input>
          </el-form-item>
        </div>
      </el-form>

      <span slot="footer" v-if="!examineApproveType">
        <el-button @click="examineShow = false" size="mini">取消</el-button>
        <el-button type="primary" @click="handleExamineOk" size="mini">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listMixin } from '@/mixins/listMixin'
import { httpAction, uploadAction } from '@/api/manage'
import { convertTime } from "@/utils/util"

export default {
  components: {},
  mixins: [listMixin],
  props: {},
  data () {
    return {
      disableMixinCreated: true,
      roleOptions: [],
      title: '操作',
      visible: false,
      confirmLoading: false,
      form: { photo: [] },
      formDisabled: false,
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      submitStaffBtnBool: false,
      typeCodeList: [
        { id: 1, label: '晚于两日内报备' },
        { id: 2, label: '晚于2个工作日内更新(桶站绑定关系)' },
        { id: 3, label: '人员信息数据错误' },
      ],
      GSSOptions: [],
      wlUserOptions: [],
      validatorRules: {
        wlUserId: [
          { required: true, message: '请输入专员名称', trigger: 'blur' },
        ],
        gssId: [
          { required: true, message: '请输入指导员姓名', trigger: 'blur' },
        ],
        email: [{ max: 32, message: '长度在32 个字符以内', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
      },
      url: {
        add: '/employeeEventRecord/add',
        getDetail: "/employeeEventRecord/detail",
        edit: '/employeeEventRecord/edit',
        searchGss: '/garbageStationSorter/queryGss',
        searchWlUser: '/wlInspectionUser/query',
        upload: "/api/upload",
        audit: "/employeeEventRecord/audit",
        queryCommunity: '/wlCommunityDict/likeSearch'
      },
      examineForm: {},
      examineInfo: {
        // causeType: '',
        // duration: '',
        // happenTime: '',
        // communityNames: '',
        // photo: '',
        // remark: '',
        // status: '',
        // auditRemark: ''
      },
      examineShow: false,
      causeTypeCode: {
        1: '三方检查',
        2: '请假',
        3: '值桶',
        4: '其他',
      },
      durationCode: {
        1: '上午',
        2: '下午',
        3: '全天',
      },
      examineFormRules: {
        status: [
          { required: true, message: '请选择审批结果', trigger: 'blur' },
        ]
      },
      examineApproveType: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    add () {
      this.edit(false)
    },
    async examineApprove (record, type) {
      this.examineApproveType = type
      this.examineShow = true
      this.examineForm.id = record.id
      let res = await httpAction(`${this.url.getDetail}/${record.id}`, {}, "get")
      if (res.code === 200) {
        this.examineInfo = Object.assign({}, res.data)
        this.examineInfo.causeType = this.causeTypeCode[this.examineInfo.causeType]
        this.examineInfo.duration = this.durationCode[this.examineInfo.duration]
        this.examineInfo.happenTime = this.examineInfo.happenTime.substr(0, 10)
        let result = await httpAction(this.url.queryCommunity, {}, "get")
        if (result.code === 200) {
          if (this.examineInfo.communityIds !== '[]') {
            let communityNames = []
            let communityIds = this.examineInfo.communityIds ? this.examineInfo.communityIds.split(',') : []
            communityIds.forEach(item => {
              let community = result.data.find(resItem => resItem.id == item)
              communityNames.push(community.name)
              // this.examineInfo.communityNames = communityNames.join()
              this.$set(this.examineInfo, 'communityNames', communityNames.join())
            })
          }
        } else {
          this.$message.error('获取社区列表失败')
        }
      } else {
        this.$message.error('查询详情失败')
      }
    },
    handleExamineOk () {
      const that = this
      this.$refs.examineFormRules.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          httpAction(this.url.audit, this.examineForm, 'post')
            .then((res) => {
              if (res.code == 200) {
                that.$message.success('操作成功')
                that.$emit('ok')
                this.examineClose()
              } else {
                that.$message.warning(res.msg)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    examineClose () {
      // this.$refs.examineFormRules.resetFields();
      this.examineForm = {}
      this.examineInfo = {}
      this.examineShow = false
    },
    async edit (record, type) {
      this.formDisabled = type
      this.visible = true
      if (!record) return
      this.remoteMethod(record.userName)
      this.remoteMethodGss(record.gssName)
      let res = await httpAction(`${this.url.getDetail}/${record.id}`, {}, "get")
      if (res.code === 200) {
        this.form = Object.assign({}, res.data)
        this.form.photo = this.form.photo ? this.form.photo : []
        let photo = res.data.photo
        let result = photo
          ? photo.reduce((pre, item, index) => {
            if (item) {
              pre.push({ uid: index, url: item })
            }
            return pre
          }, [])
          : []
        result.forEach((item) => {
          this.fileList.push(item)
        })
      } else {
        this.$message.error(String(res.msg))
      }
    },
    async remoteMethod (query) {
      if (query !== "") {
        this.loading = true
        let res = await httpAction(
          `${this.url.searchWlUser}?userName=${query}`,
          {},
          "get"
        )
        if (res.code === 200) {
          this.loading = false
          this.wlUserOptions = res.data
        } else {
          this.$message.warning = "请联系管理员"
        }
      } else {
        this.wlUserOptions = []
      }
    },
    async remoteMethodGss (query) {
      if (query !== "") {
        this.loading = true
        let res = await httpAction(
          `${this.url.searchGss}?userName=${query}`,
          {},
          "get"
        )
        if (res.code === 200) {
          this.loading = false
          this.GSSOptions = res.data
        } else {
          this.$message.warning = "请联系管理员"
        }
      } else {
        this.GSSOptions = []
      }
    },
    importFile (file) {
      this.submitStaffBtnBool = true
      let formData = new FormData()
      formData.append("businessType", 104)
      formData.append("file", file.file, file.file.name) // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传即可
      uploadAction(this.url.upload, formData)
        .then((res) => {
          this.$message.success("上传成功")
          this.form.photo.push(res.data[0])
          this.submitStaffBtnBool = false
        })
        .catch((err) => {
          this.$message.error("上传失败")
          this.submitStaffBtnBool = false
        })
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    beforeAvatarUpload (file) {
      let types = ["image/jpeg", "image/jpg", "image/bmp", "image/png"]
      const isIMG = types.includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isIMG) {
        this.$message.error("上传图片只能是 JPG、JPEG、bmp、PNG 格式!")
      }
      if (!isLt10M) {
        this.$message.error("上传头像图片大小不能超过 10MB!")
      }
      return isIMG && isLt10M
    },
    staffImgRemove () {
      this.form.photo = []
    },
    surpass () {
      this.$message.warning("最多只能上传三张图片!")
    },
    close () {
      // this.$refs.form.resetFields();
      this.form = {}
      this.fileList = []
      this.GSSOptions = []
      this.wlUserOptions = []
      this.$emit('close')
      this.visible = false
    },
    handleOk () {
      const that = this
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          const timeReg = /^(\d{4})/
          if (this.form.entryTime ? !timeReg.test(this.form.entryTime) : "") this.form.entryTime = convertTime(this.form.entryTime)
          if (this.form.leaveTime ? !timeReg.test(this.form.leaveTime) : "") this.form.leaveTime = convertTime(this.form.leaveTime)
          if (this.form.happenTime ? !timeReg.test(this.form.happenTime) : "") this.form.happenTime = convertTime(this.form.happenTime)
          httpAction(this.title === '新增' ? this.url.add : this.url.edit, this.form, 'post')
            .then((res) => {
              if (res.code == 200) {
                that.$message.success('操作成功')
                that.$emit('ok')
              } else {
                that.$message.warning(res.msg)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
  },
  created () { },
  mounted () { },
};
</script>
<style lang="scss" scoped>
.wrapper {
  .formDiv {
    margin-bottom: 22px;
    span {
      width: 120px;
      line-height: 36px;
      text-align: right;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      font-weight: 700;
      color: #606266;
      padding: 0 12px 0 0;
      box-sizing: border-box;
      cursor: default;
    }
  }
}
</style>
